export class NavbarConfig {
  sticky = '';
  animation = 'uk-animation-slide-top';
  stickyBoxShadow = '';
  stickyBackground = 'uk-navbar-default';
  mobileSticky = '';
  mobileLogo = '';
  imageWidth = 0;
  imageHeight = 0;
  mobilePopup = 'Dropdown';
  mobileFontSize = '';
  canvasMode = 'slide';
  canvasFlip = false;

  static normalize(styles: Partial<NavbarConfig>): NavbarConfig {
    const pureStyles = new NavbarConfig();

    pureStyles.sticky = styles.sticky ?? pureStyles.sticky;
    pureStyles.animation = styles.animation ?? pureStyles.animation;
    pureStyles.stickyBoxShadow = styles.stickyBoxShadow ?? pureStyles.stickyBoxShadow;
    pureStyles.stickyBackground = styles.stickyBackground ?? pureStyles.stickyBackground;
    pureStyles.mobileSticky = styles.mobileSticky ?? pureStyles.mobileSticky;
    pureStyles.mobileLogo = styles.mobileLogo ?? pureStyles.mobileLogo;
    pureStyles.imageWidth = styles.imageWidth ?? pureStyles.imageWidth;
    pureStyles.imageHeight = styles.imageHeight ?? pureStyles.imageHeight;
    pureStyles.mobilePopup = styles.mobilePopup ?? pureStyles.mobilePopup;
    pureStyles.mobileFontSize = styles.mobileFontSize ?? pureStyles.mobileFontSize;
    pureStyles.canvasMode = styles.canvasMode ?? pureStyles.canvasMode;
    pureStyles.canvasFlip = styles.canvasFlip ?? pureStyles.canvasFlip;

    return pureStyles;
  }
}
